module.exports = __webpack_public_path__ + "bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bb.svg
// module id = 692
// module chunks = 0